export default {
  en: {
    id: 'exercise_2',
    diagram: `
          <div class="two-columns angular-ngAnimate">
            <div>
              <div ng-show="vm.activeIndex >= 1" style="width: 440px;" class="step__diagram-content angular-ngAnimate" ng-style="{'background-image': vm.activeIndex === 1 ? 'url(\\'/assets/images/5a-1-step-1-bg.png\\')' : ''}">
                <div class="step__diagram-title">
                  <p>The first thing you need to do is identify the arena within which the problem is taking place.</p>
                  <p class="yellow-text">Visualize the Situation</p>
                </div>
                <div style="padding: 0;" class="step__diagram-content">
                  <p class="step__diagram-content-header" style="margin-bottom: 35px;">SITUATION (OPENING SCENE)</p>
                  <div class="step__diagram-step-1-table">
                        <p class="small-white-text">Branches completed (17%)</p>
                        <div class="block">
                            <p style="width: 17%;">30</p>
                            <p style="margin-left: 25px;">143 BRANCHES</p>
                        </div>
                        <p class="small-white-text" style="margin-top: 10px;">Months spent (41%)</p>
                        <div class="block">
                            <p style="width: 41%;">5 months</p>
                            <p>7 months</p>
                        </div>
                  </div>
                  <p style="margin-bottom: 20px; margin-top: 60px;" class="yellow-text">Let’s review what you know that is going on now in the company.</p>
                  <p class="small-white-text">Cannot extend time</p>
                  <p class="small-white-text">Cannot expand team</p>
                </div>
               </div>
            </div>

            <div class="second-column">
              <div style="display: flex">
                <div ng-show="vm.activeIndex >= 2" class="angular-ngAnimate" style="padding: 15px 0 0 15px" ng-style="{'background-image': vm.activeIndex <= 2 ? 'url(\\'/assets/images/5a-1-step-2-bg.png\\')' : ''}">
                  <div class="step__diagram-title">
                    <p class="yellow-text">State what we don’t like about the Situation (R1)</p>
                  </div>
                  <div class="step__diagram-content" style=" align-items: center; padding: 15px 10px;">
                    <p class="step__diagram-content-header">R1</p>
                    <div class="step-3__box">
                      <p class="step-3__box-text">Will not achieve goal in time remaining</p>
                    </div>
                  </div>
                </div>
                <div ng-show="vm.activeIndex >= 3" style="background-size: cover; padding: 15px 0 0 15px" class="angular-ngAnimate" ng-style="{'background-image': vm.activeIndex <= 3 ? 'url(\\'/assets/images/5a-1-step-3-bg.png\\')' : ''}">
                  <div class="step__diagram-title">
                    <p class="yellow-text">State what we want instead (R2)</p>
                  </div>
                  <div class="step__diagram-content"
                       style="align-items: center; padding: 15px 10px;">
                    <p class="step__diagram-content-header">R2</p>
                    <div class="step-3__box">
                      <p class="step-3__box-text">Achieve maximum savings possible in time remaining</p>
                    </div>
                  </div>
                </div>
              </div>
              <div ng-show="vm.activeIndex >= 4" class="angular-ngAnimate" style="display: flex; flex-direction: column; align-items: center;">
                <svg height="150" width="300" style="margin-top: -18px; margin-bottom: -32px;">
                  <line x1="25" y1="0" x2="150" y2="140" stroke-width="3" stroke="#ffffff"/>
                  <line x1="290" y1="0" x2="150" y2="140" stroke-width="3" stroke="#ffffff"/>
                </svg>
                <div class="step__diagram-content" style="background-image: url('/assets/images/5a-1-step-4-bg.png'); align-items: center; background-size: cover; padding: 15px 10px; margin-top: 28px">
                  <p class="step__diagram-content-header">SOLUTION</p>
                  <div class="step-3__box" style="width: 217px">
                    <p class="step-3__box-text">Implement only high benefit proposals </p>
                  </div>
                  <div class="step__diagram-title">
                    <p style="max-width: initial; margin-top: 20px;" class="yellow-text">State how you will get from R1 to R2 (if you know it)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>`,
    steps: 4,
    startStep: 1,
    title: 'Step one is to visualize the situation in which the team finds itself. Show what is going on?',
    pyramidData: {
      exerciseNumber: 2,
      scq: {
        s: 'Unable to finish Rationalization Program in time allotted',
        c: 'Clearly must be cut, but want to achieve maximum savings possible',
        q: 'How cut?'
      },
      scheme: {
        model: {
          textarea: 'To cut Rationalization Program to manageable size, we should implement only high benefit proposals',
        },
        children: [
          {
            model: {
              textarea: 'Adhere to the June deadline for those projects in the present backlog that require low capital expenditure',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Rigorously reappraise the remaining projects in the backlog to eliminate those that will yield low benefits',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Set realistic deadlines for completing the second group of projects',
            },
            children: [

            ]
          },
        ],
      },
      instruction: `Now you have a very clear picture of the problem and its solution in your mind. You also have an indication of the question that document has to be structured to answer. You are ready to write.`,
    }
  }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5a/defineProblem/i18n/exercise2.js